import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element"]

  connect() {
    console.log("Draggable controller connected")
    this.elementTargets.forEach(element => {
      element.addEventListener("dragstart", this.dragStart.bind(this))
      element.addEventListener("dragend", this.dragEnd.bind(this))
    })
  }

  dragStart(event) {
    const element = event.currentTarget
    console.log("Drag start:", element.dataset.elementId)

    // Set the data in multiple formats to ensure it's available
    event.dataTransfer.setData("text/plain", element.dataset.elementId)
    event.dataTransfer.setData("application/json", JSON.stringify({
      id: element.dataset.elementId,
      name: element.dataset.elementName,
      category: element.dataset.elementCategory
    }))

    // Set the effect
    event.dataTransfer.effectAllowed = "copy"

    // Add visual feedback
    element.classList.add("opacity-50")
  }

  dragEnd(event) {
    console.log("Drag end")
    event.currentTarget.classList.remove("opacity-50")
  }
}